import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AppSubscriptionGuard } from "@app/app-subscription.guard";
import { extract } from "@app/core";
import { Shell } from "@app/shell/shell.service";
import { TimerHomePageComponent } from "./timer-home-page.component";

const routes: Routes = [
	Shell.childRoutes(
		[
			{
				path: "",
				redirectTo: "/calendar-timer",
				pathMatch: "full",
			},
			{
				path: "calendar-timer",
				component: TimerHomePageComponent,
				data: { title: extract("calendar-timer.single") },
			},
		],
		{
			canActivate: [AppSubscriptionGuard],
			runGuardsAndResolvers: "always",
		}
	),
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: [],
})
export class TimerHomePageRoutingModule {}
